import { Theme } from '@mui/material/styles'
import { createUseStyles } from 'react-jss'
import { shadows } from 'src/config/styles'

export default createUseStyles((theme: Theme) => ({
  practitionerAvatar: {
    width: 44,
    height: 44,
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: `${theme.palette.grey[300]}`,
    border: `5px solid ${theme.palette.grey[100]}`,
    boxShadow: shadows[1],
    borderRadius: '100px',
    backgroundSize: 'contain',
  },
}))
